import React from 'react';
import { useTranslation } from "react-i18next";
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui';

interface LimitReachedAlertProps {
  message: string;
  onUpgradeClick: () => void;
}

export const LimitReachedAlert: React.FC<LimitReachedAlertProps> = ({ 
  message,
  onUpgradeClick
}) => {
  const { t } = useTranslation();
  return (
    <div className="relative overflow-hidden rounded-lg border-0 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-slate-950/20 dark:via-blue-950/20 dark:to-indigo-950/20 shadow-sm">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-200/20 via-blue-200/10 to-indigo-200/10 pointer-events-none" />
      
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-indigo-200/20 to-transparent rounded-full blur-2xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-blue-200/20 to-transparent rounded-full blur-xl pointer-events-none" />
      
      <div className="relative flex items-center justify-between gap-4 px-4 py-1.5">
        <div className="flex items-center gap-2">
          {/* Icon with gradient background */}
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-6 h-6 rounded-lg bg-gradient-to-br from-indigo-500 to-blue-600 shadow-sm">
              <AlertCircle className="w-4 h-4 text-white" strokeWidth={2.5} />
            </div>
          </div>
          <span className="text-sm font-medium text-slate-800 dark:text-slate-200">
            {message}
          </span>
        </div>
        <Button
          onClick={onUpgradeClick}
          size="xs"
          className="flex-shrink-0 rounded-md bg-gradient-to-r from-indigo-600 to-blue-600 px-3 py-1.5 text-sm font-medium text-white transition hover:from-indigo-700 hover:to-blue-700 shadow-sm"
        >
          {t('portal.limitReached.upgradeButton')}
        </Button>
      </div>
    </div>
  );
};

